export default {
  get_all: { method: "get", url: "api/roles" },
  show: { method: "get", url: "api/roles{/id}" },
  store: { method: "post", url: "api/roles" },
  update: { method: "put", url: "api/roles{/id}" },
  delete: { method: "delete", url: "api/roles{/id}" },
  get_all_permissions: { method: "get", url: "api/roles/permissions" }
};
